// @mui
import { styled, alpha } from "@mui/material/styles";
// utils
import { bgGradient } from "../../utils/cssStyles";

// ----------------------------------------------------------------------

export const StyledRoot = styled("main")(() => ({
  height: "100%",
  display: "flex",
  position: "relative",
}));

export const StyledRegisterRoot = styled("main")(({ theme }) => ({
  height: "100%",
  display: "flex",
  position: "relative",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const StyledSection = styled("div")(({ theme }) => ({
  display: "none",
  position: "relative",
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    display: "flex",
    alignItems: "end",
    justifyContent: "center",
    flexDirection: "column",
  },
}));

export const StyledRegisterSection = styled("div")(({ theme }) => ({
  // display: "none",
  position: "relative",
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    display: "flex",
    alignItems: "start",
    justifyContent: "flex-end",
    flexDirection: "column",
  },
  [theme.breakpoints.up("lg")]: {
    maxWidth: 1900,
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: 180,
  },
}));

export const StyledSectionBg = styled("div")(({ theme }) => ({
  // ...bgGradient({
  //   color: alpha(
  //     theme.palette.background.default,
  //     theme.palette.mode === "light" ? 0.9 : 0.94
  //   ),
  //   imgUrl: "/assets/background/overlay_2.jpg",
  // }),
  backgroundImage: "url(/assets/background/background-1.png)",
  backgroundSize: "cover",
  top: 0,
  left: 0,
  zIndex: -1,
  width: "100%",
  height: "100%",
  position: "absolute",
  transform: "scaleX(-1)",
}));

export const StyledRegisterSectionBg = styled("div")(({ theme }) => ({
  // ...bgGradient({
  //   color: alpha(
  //     theme.palette.background.default,
  //     theme.palette.mode === "light" ? 0.9 : 0.94
  //   ),
  //   imgUrl: "/assets/background/overlay_2.jpg",
  // }),
  backgroundImage: "url(/assets/background/background-register.png)",
  backgroundSize: "cover",
  top: 0,
  left: 0,
  zIndex: -1,
  width: "100%",
  height: "100%",
  position: "absolute",
  [theme.breakpoints.down("sm")]: {
    backgroundImage: "url(/assets/background/background-register-mobile.png)",
  },
}));

export const StyledContent = styled("div")(({ theme }) => ({
  width: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  justifyContent: "center",
  padding: theme.spacing(15, 2),
  [theme.breakpoints.up("md")]: {
    flexShrink: 0,
    padding: theme.spacing(30, 8, 0, 8),
  },
}));

export const StyledRegisterContent = styled("div")(({ theme }) => ({
  width: 530,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  justifyContent: "center",
  padding: theme.spacing(15, 2),
  [theme.breakpoints.up("md")]: {
    flexShrink: 0,
    padding: theme.spacing(30, 3, 0, 3),
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
